import { TransactionDto } from "dtos/wallet.transaction.dto";
import { WalletDto } from "dtos/wallet.dto";
import { T_Api_Success_Res } from "./api.types";
import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "api";

export const walletService = {
  useGetTransactionLogs: (params: {
    application_id?: string;
    creditor_id?: string;
    org_id?: string;
    wallet_type: string;
    type?: string;
    status?: string;
    search?: string;
    page?: number;
    limit?: number;
  }) => {
    return useQuery({
      queryKey: ["transaction", "central-logs", params],
      queryFn: async () => {
        const res = await api.get(`/transaction/central/logs`, {
          params,
        });

        return res.data as T_Api_Success_Res<{
          wallet: WalletDto & { balance?: number };
          reconciliation_wallet: WalletDto & { balance?: number };
          data: TransactionDto[];
          hasPrevPage: boolean;
          hasNextPage: boolean;
          prevPage: number | null;
          nextPage: number | null;
          limit: number;
          page: number;
          totalObjects: number;
          totalPages: number;
        }>;
      },
      enabled: !!params.wallet_type && (!!params.application_id || !!params.creditor_id || !!params.org_id),
    });
  },

  useReconcileTransaction: () => {
    return useMutation({
      mutationKey: ["transaction/reconcile"],
      mutationFn: async (params: {
        id: string;
        root_wallet: string;
        root_wallet_van: string;
        ref_transaction_id?: string;
        posting_date?: string | Date;
      }) => {
        const { id, ...body } = params;
        return api.post(`/transaction/reconcile/${id}`, body);
      },
    });
  },
};
